import IMedicalCertificate from '../../interfaces/IMedicalCertificate';

const formatTimeQuantity = (value: number, type: string): string => {
  if (type === 'DAY') {
    return value.toFixed(0);
  }
  const totalMinutes = Math.round(value * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
};

const getTimeQuanitity = (medicalCetificate: IMedicalCertificate | null): string => {
  let timeType = '';
  const typeTime = medicalCetificate?.typeTime || '';
  let quantity = medicalCetificate?.timeQuantity || 0;
  const timeQuantity = typeTime === 'HOUR' ? quantity : quantity / 24;

  if (typeTime === 'HOUR' && timeQuantity > 1) {
    timeType = 'Horas';
  }
  if (typeTime === 'HOUR' && timeQuantity <= 1) {
    timeType = 'Hora';
  }
  if (typeTime === 'DAY' && timeQuantity <= 1) {
    timeType = 'Dia';
  }
  if (typeTime === 'DAY' && timeQuantity > 1) {
    timeType = 'Dias';
  }

  return `${formatTimeQuantity(timeQuantity, typeTime)} ${timeType}`;
};

const status = {
  PENDING: 'Pendente',
  APPROVED: 'Aprovado',
  APPROVEDBYMANAGER: 'Aprovado pelo gestor',
  DISAPPROVED: 'Reprovado',
  DISAPPROVEDBYMANAGER: 'Reprovado pelo gestor',
  ARCHIVED: 'Arquivado',
  ARCHIVEDBYMANAGER: 'Arquivado pelo gestor',
};

const statusColors = {
  PENDING: 'gray',
  APPROVED: 'green',
  APPROVEDBYMANAGER: 'green',
  DISAPPROVED: 'red',
  DISAPPROVEDBYMANAGER: 'red',
  ARCHIVED: '#F57C00',
  ARCHIVEDBYMANAGER: '#F57C00',
};

export { getTimeQuanitity, status, statusColors };
